class HeaderSearchInline extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('[data-header-search-toggle]');
    this.panel = this.querySelector('[data-header-search-panel]');
    this.input = this.querySelector('.header-search-inline__input');
    this.mediaQuery = window.matchMedia('(max-width: 989px)');

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    this.toggleButton?.addEventListener('click', this.onToggleClick);
    this.mediaQuery.addEventListener('change', this.onMediaChange);
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.onToggleClick);
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.removeOpenListeners();
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.mediaQuery.matches) return;

    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.mediaQuery.matches || this.isOpen) return;

    this.classList.add('is-open');
    this.toggleButton?.setAttribute('aria-expanded', 'true');
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);

    requestAnimationFrame(() => {
      this.input?.focus();
    });
  }

  close() {
    if (!this.isOpen) return;

    this.classList.remove('is-open');
    this.toggleButton?.setAttribute('aria-expanded', 'false');
    this.removeOpenListeners();
  }

  removeOpenListeners() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.toggleButton?.focus();
    }
  }

  onMediaChange(event) {
    if (!event.matches) {
      this.close();
    }
  }
}

customElements.define('header-search-inline', HeaderSearchInline);
